export default "__VITE_ASSET__D40SJa4l__"